
interface IProp{
  proposal:any;
  statusActual:any;
}
const Action1 = ({proposal, statusActual}: IProp) => {
    if(proposal.salesForceId){
      if(proposal.idProposalStatus === statusActual.idProposalStatus){
        return(<span>Processando proposta.</span>)
      }else{
        return(<></>)
      }
    }else{
      return(<span>Processando proposta no salesforce.</span>)
    }
};

export default Action1;
